import { ColDef } from 'ag-grid-community';

import { commonColumns } from 'contacts/components/ContactGroupList';
import { IContactGroup } from 'contacts/types';

export const columnDef = (openDetails: (data: IContactGroup) => void): ColDef[] => {
  const { idColumn, nameColumn, contactGroupingNameColumn, websiteColumn, domainsColumn } =
    commonColumns(openDetails);

  return [idColumn, nameColumn, contactGroupingNameColumn, websiteColumn, domainsColumn];
};
